import { render, staticRenderFns } from "./_create_lesson_form.vue?vue&type=template&id=0527ef75"
import script from "./_create_lesson_form.vue?vue&type=script&lang=js"
export * from "./_create_lesson_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports